import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import Container from "../Container";

interface LegalSectionProps {
  id: string;
  title: ReactNode;
  icon: LucideIcon;
  children: ReactNode;
}

export default function LegalSection({
  id,
  title,
  icon: Icon,
  children,
}: LegalSectionProps) {
  return (
    <Container id={id} className="relative overflow-hidden">
      <div className="accent-line absolute top-0 right-0 left-0" />
      <div className="mt-2 mb-4 flex items-center gap-3">
        <Icon className="text-soluud-primary h-6 w-6" />
        <h2 className="text-soluud-text-primary text-xl font-bold">{title}</h2>
      </div>
      <div className="prose prose-slate text-soluud-text-secondary max-w-none space-y-4 leading-relaxed">
        {children}
      </div>
    </Container>
  );
}
